import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content/styles")({
  component: () => (
    <Breadcrumb label="Styles" to="/content/styles">
      <Outlet />
    </Breadcrumb>
  ),
});
